var react3layerDecorators = require('react-3layer-decorators');
var dayjs = require('dayjs');

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

class AdvancedFilter {
}

class DateFilter extends AdvancedFilter {
    constructor(fields) {
        super();
        // @MomentField()
        // public equal?: Moment;
        // @MomentField()
        // public greater?: Moment;
        // @MomentField()
        // public greaterEqual?: Moment;
        // @MomentField()
        // public less?: Moment;
        // @MomentField()
        // public lessEqual?: Moment;
        // @MomentField()
        // public notEqual?: Moment;
        Object.defineProperty(this, "equal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "greater", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "greaterEqual", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "less", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessEqual", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notEqual", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (typeof fields === 'object') {
            Object.assign(this, fields);
        }
    }
}
__decorate([
    react3layerDecorators.DayjsField(),
    __metadata("design:type", dayjs.Dayjs)
], DateFilter.prototype, "equal", void 0);
__decorate([
    react3layerDecorators.DayjsField(),
    __metadata("design:type", dayjs.Dayjs)
], DateFilter.prototype, "greater", void 0);
__decorate([
    react3layerDecorators.DayjsField(),
    __metadata("design:type", dayjs.Dayjs)
], DateFilter.prototype, "greaterEqual", void 0);
__decorate([
    react3layerDecorators.DayjsField(),
    __metadata("design:type", dayjs.Dayjs)
], DateFilter.prototype, "less", void 0);
__decorate([
    react3layerDecorators.DayjsField(),
    __metadata("design:type", dayjs.Dayjs)
], DateFilter.prototype, "lessEqual", void 0);
__decorate([
    react3layerDecorators.DayjsField(),
    __metadata("design:type", dayjs.Dayjs)
], DateFilter.prototype, "notEqual", void 0);

class IdFilter extends AdvancedFilter {
    constructor(fields) {
        super();
        Object.defineProperty(this, "in", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "equal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notEqual", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (typeof fields === 'object') {
            Object.assign(this, fields);
        }
    }
}
__decorate([
    react3layerDecorators.List(Number),
    __metadata("design:type", Array)
], IdFilter.prototype, "in", void 0);
__decorate([
    react3layerDecorators.List(Number),
    __metadata("design:type", Array)
], IdFilter.prototype, "notIn", void 0);
__decorate([
    react3layerDecorators.Field(Number),
    __metadata("design:type", Number)
], IdFilter.prototype, "equal", void 0);
__decorate([
    react3layerDecorators.Field(Number),
    __metadata("design:type", Number)
], IdFilter.prototype, "notEqual", void 0);

class GuidFilter extends AdvancedFilter {
    constructor(fields) {
        super();
        Object.defineProperty(this, "equal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "in", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notEqual", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (typeof fields === 'object') {
            Object.assign(this, fields);
        }
    }
}
__decorate([
    react3layerDecorators.Field(String),
    __metadata("design:type", String)
], GuidFilter.prototype, "equal", void 0);
__decorate([
    react3layerDecorators.List(String),
    __metadata("design:type", Array)
], GuidFilter.prototype, "in", void 0);
__decorate([
    react3layerDecorators.Field(String),
    __metadata("design:type", String)
], GuidFilter.prototype, "notEqual", void 0);
__decorate([
    react3layerDecorators.List(String),
    __metadata("design:type", Array)
], GuidFilter.prototype, "notIn", void 0);

class NumberFilter extends AdvancedFilter {
    constructor(fields) {
        super();
        Object.defineProperty(this, "equal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "greater", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "greaterEqual", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "less", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lessEqual", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notEqual", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (typeof fields === 'object') {
            Object.assign(this, fields);
        }
    }
}
__decorate([
    react3layerDecorators.Field(Number),
    __metadata("design:type", Number)
], NumberFilter.prototype, "equal", void 0);
__decorate([
    react3layerDecorators.Field(Number),
    __metadata("design:type", Number)
], NumberFilter.prototype, "greater", void 0);
__decorate([
    react3layerDecorators.Field(Number),
    __metadata("design:type", Number)
], NumberFilter.prototype, "greaterEqual", void 0);
__decorate([
    react3layerDecorators.Field(Number),
    __metadata("design:type", Number)
], NumberFilter.prototype, "less", void 0);
__decorate([
    react3layerDecorators.Field(Number),
    __metadata("design:type", Number)
], NumberFilter.prototype, "lessEqual", void 0);
__decorate([
    react3layerDecorators.Field(Number),
    __metadata("design:type", Number)
], NumberFilter.prototype, "notEqual", void 0);

class StringFilter extends AdvancedFilter {
    constructor(fields) {
        super();
        Object.defineProperty(this, "contain", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "endWith", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "equal", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notContain", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notEndWith", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notEqual", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "notStartWith", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "startWith", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        if (typeof fields === 'object') {
            Object.assign(this, fields);
        }
    }
}
__decorate([
    react3layerDecorators.Field(String),
    __metadata("design:type", String)
], StringFilter.prototype, "contain", void 0);
__decorate([
    react3layerDecorators.Field(String),
    __metadata("design:type", String)
], StringFilter.prototype, "endWith", void 0);
__decorate([
    react3layerDecorators.Field(String),
    __metadata("design:type", String)
], StringFilter.prototype, "equal", void 0);
__decorate([
    react3layerDecorators.Field(String),
    __metadata("design:type", String)
], StringFilter.prototype, "notContain", void 0);
__decorate([
    react3layerDecorators.Field(String),
    __metadata("design:type", String)
], StringFilter.prototype, "notEndWith", void 0);
__decorate([
    react3layerDecorators.Field(String),
    __metadata("design:type", String)
], StringFilter.prototype, "notEqual", void 0);
__decorate([
    react3layerDecorators.Field(String),
    __metadata("design:type", String)
], StringFilter.prototype, "notStartWith", void 0);
__decorate([
    react3layerDecorators.Field(String),
    __metadata("design:type", String)
], StringFilter.prototype, "startWith", void 0);

exports.AdvancedFilter = AdvancedFilter;
exports.DateFilter = DateFilter;
exports.GuidFilter = GuidFilter;
exports.IdFilter = IdFilter;
exports.NumberFilter = NumberFilter;
exports.StringFilter = StringFilter;
//# sourceMappingURL=index.js.map
